'use strict';

exports.__esModule = true;
exports.default = NoPurposeError;
function NoPurposeError(message) {
  this.name = 'NoPurposeError';
  this.message = message || 'Perimeter must have a purpose.';
}

NoPurposeError.prototype = Error.prototype;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/errors/NoPurposeError.js
// module id = uYmw
// module chunks = 0